import { StatusIcon } from '@components/StatusIcon';
import { StatusIconType } from '@components/StatusIcon/enums';
import { Translate } from '@hooks/useI18n';
import { IAllocation } from '@schemas/opsPortal/types/allocationDetails';
import { RecordedStatus } from './enums';

interface IPostedInMonetaProps {
  allocation: IAllocation;
  translate: Translate;
}

export const PostedInMoneta = ({
  allocation,
  translate,
}: IPostedInMonetaProps) => {
  const icons = {
    check: (
      <StatusIcon
        tooltip={translate(
          'OPS_PORTAL.LABEL.BANK_ACCOUNT_RECONCILIATIONS.SUCCESSFULLY_POSTED_TO_MONETA',
        )}
        type={StatusIconType.Success}
      />
    ),
    pending: (
      <StatusIcon
        tooltip={translate(
          'OPS_PORTAL.LABEL.BANK_ACCOUNT_RECONCILIATIONS.PENDING_POSTED_TO_MONETA',
        )}
        type={StatusIconType.Pending}
      />
    ),
    cross: (
      <StatusIcon
        tooltip={translate(
          'OPS_PORTAL.LABEL.BANK_ACCOUNT_RECONCILIATIONS.FAILED_TO_POST_TO_MONETA',
        )}
        type={StatusIconType.Error}
      />
    ),
  };

  const icon = {
    [RecordedStatus.Complete]: icons.check,
    [RecordedStatus.Failure]: icons.cross,
    [RecordedStatus.Pending]: icons.pending,
    [RecordedStatus.Skipped]: icons.check,
  };

  return <>{icon[allocation.recorded_status]}</>;
};
